import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const RequireAuth = ({ token }) => {
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default RequireAuth;
